import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {ToggleContext} from '@/builder/blocks/toggle'

export function ToggleContextProvider({attributes, children}) {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <div {...attributes}>
            <ToggleContext.Provider value={{isOpen, setIsOpen}}>{children}</ToggleContext.Provider>
        </div>
    )
}

ToggleContextProvider.propTypes = {
    attributes: PropTypes.object,
    children: PropTypes.node
}

export const ToggleContextProviderDefinition = {
    component: ToggleContextProvider,
    name: 'ToggleContextProvider',
    canHaveChildren: true,
    noWrap: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/toggle-off.svg',
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'ToggleButton',
                options: {}
            },
            children: [
                {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    id: 'builder-bc2e6c73de594bc0bd9c57d6dd09f6d2',
                    component: {
                        name: 'Text',
                        options: {
                            text: 'Toggle Button'
                        }
                    }
                }
            ]
        },
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'ToggleContent',
                options: {}
            },
            children: [
                {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    id: 'builder-bc2e6c73de594bc0bd9c57d6dd09f6d2',
                    component: {
                        name: 'Text',
                        options: {
                            text: 'Toggle Content'
                        }
                    }
                }
            ]
        }
    ]
}
